import type { Position } from '@rio-cloud/rio-uikit/mapTypes';

import type { TourStopMapItem } from './tourStopsMap.utils.ts';

type ScreenPoint = {
    x: number;
    y: number;
};

export type TourStopCollisionGroup = TourStopMapItem[];

const COLLISION_DISTANCE = 20;

export const getTourStopCollisionGroups = (
    items: TourStopMapItem[],
    getScreenPoint: (position: Position) => ScreenPoint
): TourStopCollisionGroup[] => {
    const points = items.map(item => getScreenPoint(item.position));
    const unvisitedIndexes = new Set(items.map((_, index) => index));
    const groups: TourStopCollisionGroup[] = [];

    for (let anchorIndex = 0; anchorIndex < items.length; anchorIndex += 1) {
        if (!unvisitedIndexes.delete(anchorIndex)) {
            continue;
        }
        const groupedIndexes = [anchorIndex];
        const anchorPoint = points[anchorIndex];

        for (const candidateIndex of unvisitedIndexes) {
            const candidatePoint = points[candidateIndex];
            if (Math.hypot(candidatePoint.x - anchorPoint.x, candidatePoint.y - anchorPoint.y) <= COLLISION_DISTANCE) {
                unvisitedIndexes.delete(candidateIndex);
                groupedIndexes.push(candidateIndex);
            }
        }

        if (groupedIndexes.length > 1) {
            groups.push(groupedIndexes.map(index => items[index]));
        }
    }

    return groups;
};
